import script from "./DoctorFAQBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorFAQBoard.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorFAQBoard.vue?vue&type=style&index=0&id=0f625a5e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f625a5e"]])

export default __exports__